// src/layouts/SekolahLayout.jsx

import React from "react";
import { AppShell } from "@mantine/core";
import { Routes, Route, Navigate } from "react-router-dom"; // Import Navigate

// Komponen UI
import { NavbarMinimal } from "../components/NavbarMinimal";
import { HeaderMegaMenu } from "../components/HeaderMegaMenu";
import { FooterSimple } from "../components/FooterSimple";

// Halaman
import DashboardSupervisor from "../pages/supervisor/SupervisorDashboardPage";
import DistribusiSupervisor from "../pages/supervisor/DistribusiSupervisorPage";
import LaporanNutrisiPage from "../pages/supervisor/LaporanNutrisiPage";
import LaporanMonitoringPage from "../pages/supervisor/LaporanMonitoringPage";

export default function SupervisorLayout() {
  return (
    <AppShell
      padding="md"
      header={{ height: 60 }}
      navbar={{ width: 80, breakpoint: "sm" }}
      footer={{ height: 50 }}
    >
      <AppShell.Header>
        <HeaderMegaMenu />
      </AppShell.Header>

      <AppShell.Navbar p={0}>
        <NavbarMinimal />
      </AppShell.Navbar>

      <AppShell.Footer p={0}>
        <FooterSimple />
      </AppShell.Footer>

      <AppShell.Main>
        <Routes>
          {/* Halaman Dashboard */}
          <Route path="dashboard" element={<DashboardSupervisor />} />
          <Route path="/distribusi" element={<DistribusiSupervisor />} />
          <Route path="/laporan-nutrisi" element={<LaporanNutrisiPage />} />
          <Route path="/laporan-monitoring" element={<LaporanMonitoringPage />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}
